// extracted by mini-css-extract-plugin
export default {"accordion_summary":"styles_accordion_summary__3wKXm","accordion_button__wrapper":"styles_accordion_button__wrapper__d5CQi"};